(function () {
  const form = document.querySelector('[data-region-form]');
  if (!form) return;

  const dropdown = form.querySelector('[data-region-dropdown]');
  const trigger = form.querySelector('[data-region-trigger]');
  const list = form.querySelector('[data-region-list]');
  const input = form.querySelector('[data-region-input]');
  const labelEl = form.querySelector('[data-region-label]');
  const cta = form.querySelector('[data-region-cta]');
  if (!dropdown || !trigger || !list || !input || !labelEl || !cta) return;

  const updateCta = () => {
    cta.disabled = !input.value;
  };

  const open = () => {
    dropdown.classList.add('region-selector__dropdown--open');
    trigger.setAttribute('aria-expanded', 'true');
  };

  const close = () => {
    dropdown.classList.remove('region-selector__dropdown--open');
    trigger.setAttribute('aria-expanded', 'false');
  };

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.contains('region-selector__dropdown--open') ? close() : open();
  });

  list.addEventListener('click', (e) => {
    const item = e.target.closest('[data-value]');
    if (!item) return;

    list.querySelectorAll('[data-value]').forEach((el) => {
      el.classList.remove('region-selector__dropdown-item--selected');
      el.setAttribute('aria-selected', 'false');
    });
    item.classList.add('region-selector__dropdown-item--selected');
    item.setAttribute('aria-selected', 'true');

    input.value = item.dataset.value;
    labelEl.textContent = item.textContent.trim();
    trigger.classList.remove('region-selector__dropdown-trigger--placeholder');
    updateCta();
    close();
  });

  list.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const item = e.target.closest('[data-value]');
      if (item) item.click();
    }
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) close();
  });

  updateCta();

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (input.value) window.location.href = input.value;
  });
})();
